import { render, staticRenderFns } from "./RqtaEditAbout.vue?vue&type=template&id=203e9aad&scoped=true&"
import script from "./RqtaEditAbout.vue?vue&type=script&lang=js&"
export * from "./RqtaEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e9aad",
  null
  
)

export default component.exports